/**
 * Regras do logo da plataforma (White-Label). SVG fica de fora de propósito:
 * o bucket `assets` é público e um SVG servido com `image/svg+xml` executa script.
 */
const EXTENSAO_POR_TIPO: Readonly<Record<string, string>> = {
  'image/png':  'png',
  'image/jpeg': 'jpg',
  'image/webp': 'webp',
};

export const TIPOS_LOGO_ACEITOS = Object.keys(EXTENSAO_POR_TIPO).join(',');

export const TAMANHO_MAX_LOGO_BYTES = 2 * 1024 * 1024;

export function extensaoLogo(tipo: string): string | null {
  return Object.prototype.hasOwnProperty.call(EXTENSAO_POR_TIPO, tipo) ? EXTENSAO_POR_TIPO[tipo] : null;
}

export function validarArquivoLogo(file: Pick<File, 'type' | 'size'>): string | null {
  if (extensaoLogo(file.type) === null) return 'Formato inválido. Use PNG, JPEG ou WebP.';
  if (file.size > TAMANHO_MAX_LOGO_BYTES) return 'Arquivo muito grande. Máximo 2 MB.';
  return null;
}
